import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { cn } from '@anytag/shared-utils';
import { Icon } from '../Icon';

function Accordion({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

function AccordionItem({ className, ...props }: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn('border-b-border outline-none last:border-b-0', className)}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  hasIcon = true,
  hasHover = true,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger> & {
  open?: boolean;
  hasIcon?: boolean;
  hasHover?: boolean;
}) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          'flex h-10 flex-1 cursor-pointer items-center justify-between gap-4 rounded-md bg-white px-3 text-left text-size-input font-normal outline-none',
          hasHover && 'hover:bg-light-gray',
          'group', // to manage open/close state in child component
          className
        )}
        {...props}
      >
        {children}
        {hasIcon && <Icon icon={props.open ? 'minus' : 'plus'} size="10px" variant="gray" />}
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className={cn(
        'overflow-hidden border-t-border bg-light-gray px-4 text-base',
        'data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
        className
      )}
      {...props}
    >
      <div className={cn('pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent, AccordionPrimitive };
